import { projectStages } from 'define/calculator';

export const calculatorConfig = {
  id: 'ruby-calculator',
  formName: 'price-technology',
  title: 'Get a price estimate of your Ruby on Rails Software Development Services',

  sections: [
    {
      name: 'stage',
      type: 'stage',
      blockType: 'radioButton',
      counterType: 'radio',
      totalBoxType: 'string',
      defaultValue: false,
      title: 'What is the current stage of your software development process?',
      mobileTitles: {
        default: 'Your current project stage',
        active: 'Your current project stage',
        section: 'Your current project stage',
      },
      items: projectStages,
      accordion: true,
      borderBottom: false,
    },
    {
      name: 'specialists',
      type: 'team',
      blockType: 'counter',
      counterType: 'counter',
      defaultValue: 0,
      title: 'Your Back-end team',
      mobileTitles: {
        default: 'Your Back-end team',
        active: 'Your Back-end team',
        section: 'Your Back-end team',
      },
      items: ['Developer', 'Senior Developer', 'Architect'],
      accordion: true,
      borderBottom: false,
    },
    {
      name: 'additional_skills',
      type: 'skills',
      blockType: 'checkbox',
      counterType: 'checkbox',
      defaultValue: false,
      title: 'Top required skills',
      mobileTitles: {
        default: 'Top required skills',
        active: 'Top required skills',
        section: 'Top required skills',
      },
      items: ['Rails', 'Hanami', 'Sinatra', 'dry-rb', 'Cloud platforms', 'Front-end'],
      accordion: true,
      borderBottom: false,
    },
  ],
};
